import { render, staticRenderFns } from "./genres-list.vue?vue&type=template&id=382ca5d0&scoped=true&"
import script from "./genres-list.vue?vue&type=script&lang=js&"
export * from "./genres-list.vue?vue&type=script&lang=js&"
import style0 from "./genres-list.vue?vue&type=style&index=0&id=382ca5d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ca5d0",
  null
  
)

export default component.exports